import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{staticClass:"ma-2 white--text",attrs:{"color":_vm.counterChipClass}},[_c(VAvatar,{attrs:{"left":"","color":_vm.counterAvatarClass}},[_vm._v(" "+_vm._s(_vm.counter)+" ")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }